import axios from 'axios';

const serverURL = process.env.NODE_ENV === 'production' ? "https://api.shanguoyingyu.com" : ""

axios.defaults.baseURL = serverURL


// 通用公用方法
const req = (method, url, params) => {
    // console.log(params)
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
            'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
            'token': localStorage.getItem('token'),
        },
        data: {
            ...params,
            user: {
                account: "",
                userId: 0,
                username: ""
            }
        },

    }).then(res => res.data);
};

export {
    req,
    serverURL
}


// WEBPACK FOOTER //
// ./src/api/axiosFun.js